import { useEffect, useRef, useState } from 'react';

type Status = 'loading' | 'ready' | 'error';

export function useDos(bundleUrl: string) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [status, setStatus] = useState<Status>('loading');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    if (typeof window.Dos !== 'function') {
      setStatus('error');
      setError('js-dos failed to load. Check your network connection and reload.');
      return;
    }

    let cancelled = false;
    let instance: DosInstance | null = null;
    try {
      instance = window.Dos(container, {
        url: bundleUrl,
        theme: 'dark',
        backend: 'dosboxX',
      });
      setStatus('ready');
    } catch (e) {
      setStatus('error');
      setError(e instanceof Error ? e.message : String(e));
    }

    return () => {
      cancelled = true;
      const i = instance;
      instance = null;
      if (i) {
        // js-dos init is async; defer stop until after the current microtask
        // so the in-flight bundle load doesn't race the dispose.
        Promise.resolve()
          .then(() => i.stop())
          .catch(() => {
            // already torn down or never finished initing — fine
          });
      }
      void cancelled;
    };
  }, [bundleUrl]);

  return { containerRef, status, error };
}
